import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import Loader from 'components/Loader';
import Loading from 'components/Loading';
import {
  MODALS,
  fetchTeamDetail,
  addTeamLocation,
  removeTeamLocation
} from 'ducks/teams';
import {fetchLocations, selectLocations} from 'ducks/locations';
import {splitListBy} from 'utils/common';
import {
  MODALS as BASE_MODALS,
  openModal,
  closeModal,
  storeDataInModal
} from 'ducks/modals';

import './styles.css';

const CurrentLocationRow = ({location, onRemove}) => (
  <div className="locationRow">
    <Avatar url={location.thumbnailImage} initials="" />
    <div className="info">
      <div className="name">{location.name}</div>
      <div className="address">{_.get(location, 'address.country')}</div>
    </div>
    <Button white onClick={() => onRemove(location)}>
      Remove
    </Button>
  </div>
);

const OtherLocationsRow = ({location, onAdd}) => (
  <div className="locationRow">
    <Avatar url={location.thumbnailImage} initials="" />
    <div className="info">
      <div className="name">{location.name}</div>
      <div className="address">{_.get(location, 'address.country')}</div>
    </div>
    <Button white onClick={() => onAdd(location.ref)}>
      Add
    </Button>
  </div>
);

class ManageLocationsModal extends React.Component<any> {
  componentDidMount() {
    const {teamId} = this.props.data;
    const extraActions = this.props.storeDataExtraActions(data => ({
      team: data
    }));

    this.props.fetchLocations();
    this.props.fetchTeamDetail({teamId}, extraActions);
  }

  getExtraActions = () => {
    const {team} = this.props.data;
    const extraActions = [
      ...this.props.storeDataExtraActions(data => ({
        team: data
      })),
      data =>
        this.props.storeDataInModal({
          modalName: MODALS.TEAM_DETAILS,
          data: {
            team: data
          }
        })
    ];

    return [
      () => fetchLocations(),
      () => fetchTeamDetail({teamId: team.id}, extraActions)
    ];
  };

  updateTeamExtraActions = () => {
    const {team} = this.props.data;

    return [
      ...this.getExtraActions(),
      ...this.props.storeDataExtraActions(() => ({
        team: {
          ...team,
          isLoading: true
        }
      }))
    ];
  };

  onAddLocaton = locationRef => {
    const {team} = this.props.data;

    this.props.addTeamLocation(
      {teamId: team.id, locationRef},
      this.updateTeamExtraActions()
    );
  };

  onRemoveLocation = location => {
    const {team} = this.props.data;

    const extraActions = [
      ...this.updateTeamExtraActions(),
      () => closeModal(BASE_MODALS.CONFIRM)
    ];

    const confirmAction = () =>
      this.props.removeTeamLocation(
        {teamId: team.id, locationRef: location.ref},
        extraActions
      );

    const question = (
      <div>
        Are you sure you want to remove the location <b>{location.name}</b>?
      </div>
    );

    this.props.openModal(BASE_MODALS.CONFIRM, {
      danger: true,
      heading: 'Remove Location',
      question,
      confirmAction
    });
  };

  splitLocations = (locations, team) =>
    splitListBy(
      locations,
      location =>
        _.get(team, 'locations', []).filter(x => x.id === location.id).length >
        0
    );

  render() {
    const {team, locations} = this.props.data;
    const [currentLocations, otherLocations] = this.splitLocations(
      locations,
      team
    );

    return (
      <Modal
        className="ManageLocationsModal"
        type={Modal.EXTRA_SMALL}
        show={true}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Manage Locations" />
        <Modal.Body>
          {_.isNil(team) && <Loader />}
          {!_.isNil(team) && (
            <React.Fragment>
              <div className="content">
                <div className="heading">Current Locations</div>
                {_.get(team, 'isLoading') && <Loading />}
                <div className="container">
                  {_.isEmpty(currentLocations) && (
                    <div className="noLocationsMessage">
                      This team has no locations yet. Add the first one!
                    </div>
                  )}
                  {currentLocations.map((location: {ref: string}) => (
                    <CurrentLocationRow
                      key={location.ref}
                      location={location}
                      onRemove={this.onRemoveLocation}
                    />
                  ))}
                </div>
                <div className="heading">Other Locations</div>
                <div className="container">
                  {otherLocations.map((location: {ref: string}) => (
                    <OtherLocationsRow
                      key={location.ref}
                      location={location}
                      onAdd={this.onAddLocaton}
                    />
                  ))}
                  {_.isEmpty(otherLocations) && (
                    <div className="noLocationsMessage">
                      This team has all the locations
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={this.props.closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    locations: selectLocations(state)
  };
};

const mapDispatchToProps = {
  fetchLocations,
  fetchTeamDetail,
  addTeamLocation,
  removeTeamLocation,
  openModal,
  storeDataInModal
};

export default withModal(
  MODALS.MANAGE_TEAM_LOCATIONS,
  mapStateToProps,
  mapDispatchToProps
)(ManageLocationsModal);
